import { useQuery } from '@tanstack/react-query';

import { getPermissions } from '../api';

export const usePermissions = () =>
  useQuery({
    queryKey: ['tenant-permissions'],
    queryFn: getPermissions,
  });
